// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2jVgw","tab":"Tabs_tab__hCtWJ","tabActive":"Tabs_tabActive__YnH0B"};